import { useEffect, useState } from 'react';
import { globalEmitter } from '../helpers/emitter';
import { FormValidate } from './FormValidate';
import { Modal } from './Modal';
import { SelectInput } from './SelectInput';
import { OmneoList, type_WISHLIST_DASHBOARD_STATE } from '../types';
import { closeModal } from '../helpers/useModal';
import { wishlistProviderService } from '../helpers/provider.service';

declare var wishlistDashboardState: type_WISHLIST_DASHBOARD_STATE

export function WishlistSettingList ({ currentList }: { lists: OmneoList[], currentList: OmneoList }) {
  return (
    <Modal
      id="setting-list-slideout"
      className="modal-wishlist top-auto"
      content={<ModalSettingListContent currentList={currentList} />}
      type="slideout"
    />
  )
}

function ModalSettingListContent({ currentList }: { currentList: OmneoList }) {
  const [key, setKey] = useState(0)

  const listPrivacy = [
    {
      "name": "Private",
      "value": "private"
    },
    {
      "name": "Public",
      "value": "public"
    }
  ].filter((option) => option.value === 'public' || !currentList.is_shared)

  const showMessageError = (message: string) => {
    globalEmitter.emit('triggerNotification', { message, type: 'error' })
  }

  const showMessSuccess = (message: string) => {
    globalEmitter.emit('triggerNotification', { message, type: 'success' })
  }

  const saveSetting = async (formEl: HTMLFormElement | null) => {
    if (!formEl) return
    const formData = new FormData(formEl)
    const privacy = formData.get('privacy')
    const currentName = currentList.name.trim()
    const nextIsShared = privacy === 'public'

    if (currentList.is_shared && !nextIsShared) {
      showMessageError('Public Swym lists cannot be made private')
      return
    }

    if (
      currentName.toLowerCase() === currentName.toLowerCase() &&
      nextIsShared === currentList.is_shared
    ) {
      showMessageError('Update list failed')
      closeModal('setting-list-slideout')
      return
    }

    try {
      const list = await wishlistProviderService.updateList(currentList, {
        name: currentName,
        isShared: nextIsShared
      })
      if (list) {
        globalEmitter.emit('updateList', { list })
        showMessSuccess('Update list successfully')
        closeModal('setting-list-slideout')
      } else {
        showMessageError('Update list failed')
      }
    } catch (error) {
      console.log(error)
      showMessageError('Update list failed')
    }
  }

  const handleDelete = async () => {
    try {
      const res = await wishlistProviderService.deleteList(currentList.id)
      if (res) {
        globalEmitter.emit('deleteList', { list: currentList })
        showMessSuccess('list deleted successfully')
        closeModal('setting-list-slideout')
      } else {
        showMessageError('Delete list failed')
      }
    } catch (error) {
      console.log(error)
      showMessageError('Delete list failed')
    }
    closeModal('setting-list-slideout')
  }

  useEffect(() => {
    setKey(Math.random())
  }, [currentList]);

  return (
    <FormValidate
      key={key}
      id={'wishlist-settings'}
      submitForm={saveSetting}
    >
      <h3 className="text-base text-deep-grey uppercase mb-[22px] text-left md:mb-6">{wishlistDashboardState.settings.title}</h3>
      <SelectInput
        id="wishlist_privacy"
        label="Privacy"
        name="privacy"
        value={currentList.is_shared ? 'public' : 'private'}
        items={listPrivacy}
        wrapClass="mb-[22px] md:mb-6"
      />
      {currentList.is_shared && <p className="text-xs text-deep-grey mb-[22px] md:mb-6">Public lists cannot be made private.</p>}
      <p className="text-xs text-deep-grey mb-[22px] md:mb-6">{wishlistDashboardState.settings.description}</p>
      <button className="Button Button--tertiary w-full" type={'submit'}>{wishlistDashboardState.settings.save}</button>
      <button className="Button Button--secondary-dark w-full mt-3" type={'button'} onClick={handleDelete}>{wishlistDashboardState.settings.delete}</button>
    </FormValidate>
  )
}
